import React from 'react'
import { useParams } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import Details from './cards/Details'
import Notes from './cards/Notes'
import Status from './cards/Status'
import RemitDetails from './cards/RemitDetails'
import Msa from './cards/MSA'
import Benefits from './cards/Benefits'
import PointOfContacts from './cards/PointOfContact'
import CreatedUpdated from './cards/CreatedUpdated'
import RouteError from '../../../../helpers/RouteError'
import Attachments from '../../../../components/Attachments'
import { useStaffingAgencyDetailsById } from 'src/queries'

const StaffingAgency: React.FC = (props) => {
  const { id } = useParams()
  if (typeof id !== 'string') {
    throw new RouteError('Invalid Staffing Agency ID.', { status: 404 })
  }
  const agency = useStaffingAgencyDetailsById(id)
  if (agency === null) {
    throw new RouteError(`Staffing Agency "${id}" does not exist.`, { status: 404 })
  }
  return (
    <>
      <Row className='mb-4'>
        <Col md='7'>
          <Row>
            <Col>
              <Details id={id} />
            </Col>
          </Row>
        </Col>
        <Col className='d-none d-md-flex'>
          <Status id={id} />
        </Col>
      </Row>
      <Row className='gy-4'>
        <Col md='7'>
          <Row className='mb-4 gy-4'>
            <Col xs='12'>
              <Benefits id={id} />
            </Col>
            <Col md='6'>
              <RemitDetails id={id} />
            </Col>
            <Col md='6'>
              <Msa id={id} />
            </Col>
          </Row>
          <Row className='mb-4 gy-4'>
            <Col xs='12'>
              <PointOfContacts id={id} />
            </Col>
          </Row>
        </Col>
        <Col>
          <Row className='mb-4 gy-4'>
            <Col xs='12'>
              <Attachments link={id} type='680f9e799a4cf907428a8677' model='Distribution_Subcategory' editPermissionKey='CAT_EDIT' />
            </Col>
            <Col xs='12'>
              <Notes id={id} />
            </Col>
            <Col xs='12'>
              <CreatedUpdated id={id} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default StaffingAgency
